import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBison = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.75 4.75L4.25 7.60714M8.75 4.75L13.25 7.60714M8.75 4.75H3.41667L3.41667 0.75H0.75L0.75 7.60714H4.25M8.75 4.75H14.0833V0.75H16.75V7.60714H13.25M4.25 7.60714L4.25 16.75L8.75 15.0357L13.25 16.75V7.60714",
		stroke: "black",
		strokeWidth: 1.5,
		strokeLinejoin: "bevel"
	})
});
export default SvgBison;
